import { IAbUseExperiment } from '../../types/abUseExperiments';

export const abUseExperimentsReducer = (state: IAbUseExperiment[] = []) => state;
